import { render, staticRenderFns } from "./phoneIcon.vue?vue&type=template&id=7d40f442"
import script from "./phoneIcon.vue?vue&type=script&lang=js"
export * from "./phoneIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports